import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignSystemModule } from '@peca/design-system';

import { ToastComponent } from './components/toast/toast.component';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { UserExpressComponent } from './components/user-express/user-express.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OrderReturnReasonPipe } from './pipes/order-return/order-return-reason.pipe';
import { OrderReturnJustificationPipe } from './pipes/order-return/profile-order-return-justification.pipe';
import { OrderReturnRejectionPipe } from './pipes/order-return/profile-order-return-rejection.pipe';

const exportables = [
  ToastComponent,
  LoadingOverlayComponent,
  UserExpressComponent,
  OrderReturnReasonPipe,
  OrderReturnJustificationPipe,
  OrderReturnRejectionPipe,
];

@NgModule({
  imports: [CommonModule, DesignSystemModule, ReactiveFormsModule],
  declarations: [...exportables],
  exports: [...exportables],
})
export class CommonsModule {}
